import styled from '@emotion/styled';
import media from '@shared/mediaQuery';

const FursysFooterStyle = styled('div')`
  background-color: #222222;
  width: 100%;
  ${media.mobile} {
    padding-bottom: 65px;
  }
  .footerContent {
    color: #ffffff;
    ${media.desktop} {
      width: 1080px;
      margin: auto;
      padding: 0 0 89px;
    }
    ${media.mobile} {
      padding-top: 48px;
    }
    .topContent {
      ${media.desktop} {
        padding-top: 118px;
        width: 1080px;
        margin: 0 auto 60px;
        display: flex;
      }
      ${media.mobile} {
        margin-right: 68px;
        width: 270px;
        margin: auto;
        margin-bottom: 38px;
      }
      .question {
        ${media.desktop} {
          margin-left: 69px;
        }
        &--title {
          font-size: 26px;
          color: #faeeec;
          font-family: 'Pretendard-Bold';
          margin-bottom: 20px;
          letter-spacing: -0.3px;
          ${media.mobile} {
            font-size: 20px;
            margin-bottom: 6px;
          }
        }
        &--info {
          .info-data {
            &--infoMark {
              font-family: 'Gilroy-ExtraBold';
              font-size: 18px;
              color: #ff5500;
              margin-right: 3px;
            }
            &--infoContent {
              font-family: 'Gilroy-ExtraBold';
              font-size: 18px;
              letter-spacing: 1px;
              color: #faeeec;
            }
          }
          .number {
            margin-bottom: 6px;
            ${media.mobile} {
              margin-bottom: 1px;
            }
          }
        }
      }
      .notice {
        ${media.desktop} {
          margin-left: 81px;
          margin-top: 2px;
        }
        ${media.mobile} {
          margin-top: 16px;
        }
        &--title {
          font-family: 'Pretendard-Regular';
          font-size: 16px;
          letter-spacing: -0.3px;
          color: #757575;
          ${media.mobile} {
            font-family: 'Pretendard-Bold';
          }
        }
        &--content {
          line-height: 28px;
          font-family: 'Pretendard-Regular';
          font-size: 16px;
          letter-spacing: -0.3px;
          color: #757575;
          position: relative;
          ${media.desktop} {
            margin-top: 5px;
            padding-left: 7px;
          }
          ${media.mobile} {
            margin-top: 1px;
            font-size: 12px;
            line-height: 18px;
            padding-left: 7px;
          }
          &::before {
            position: absolute;
            content: '';
            width: 3px;
            height: 3px;
            background-color: #757575;
            border-radius: 50%;
            left: 0;
            top: 50%;
            ${media.mobile} {
              top: 8px;
            }
          }
        }
      }
    }

    .ifLawyer {
      border: solid 1px #c1b3ac;
      margin: auto;
      position: relative;
      ${media.desktop} {
        width: 1080px;
        height: 98px;
      }
      ${media.mobile} {
        height: 82px;
        width: calc(100% - 40px);
        padding-top: 15px;
      }
      &--text {
        ${media.desktop} {
          margin-left: 68px;
        }

        .title {
          color: #c1b3ac;
          font-size: 20px;
          font-family: 'Pretendard-Bold';
          ${media.desktop} {
            line-height: 100px;
          }
          ${media.mobile} {
            margin-left: 32px;
            font-size: 16px;
            line-height: 20px;
          }
        }
        .sub {
          font-size: 14px;
          font-family: 'Pretendard-Regular';
          ${media.desktop} {
            line-height: 92px;
            margin-left: 24px;
          }
          ${media.mobile} {
            font-size: 13px;
          }
        }
      }
      &-landing {
        cursor: pointer;
        ${media.desktop} {
          position: absolute;
          top: 20px;
          right: 68px;
          display: flex;
        }
        .link {
          font-family: 'Pretendard-Bold';
          font-size: 14px;
          color: #ff5500;
          margin-right: 16px;
          height: 17px;
          padding-bottom: 3px;
          margin-top: 18px;
          border-bottom: solid 1px #ff5500;
          ${media.mobile} {
            display: block;
            width: 45px;
            margin-left: 33px;
            font-size: 12px;
            margin-top: 3px;
            line-height: 24px;
          }
        }
        .imgWrapper {
          position: relative;
          ${media.mobile} {
            position: absolute;
            top: 18px;
            right: 31px;
          }
          .lawyer-icon {
            width: 58px;
            height: 58px;
            ${media.mobile} {
              position: relative;
              width: 58px;
              height: 58px;
            }
          }
          .plusIcon {
            width: 19px;
            height: 19px;
            background-color: #ff5500;
            border-radius: 50%;
            position: absolute;
            bottom: 5px;
            right: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            .plus {
              margin-left: -1px;
              margin-top: -3px;
            }
          }
        }
      }
    }
  }
`;

export default FursysFooterStyle;
